import { render, staticRenderFns } from "./ActionListSettingsForm.vue?vue&type=template&id=d63f0d60&"
import script from "./ActionListSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./ActionListSettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports